import { useMemo, useState } from 'react';
import { CtaButton } from '@/components/Cta/Cta';
import { useCustomerContext } from '@/lib/customer/CustomerContext';
import { isValidEmail as _isValidEmail } from '@/lib/isValidEmail';
import { AUTH_STEPS } from '../../constants';
import { StepProps } from '../types';
import i18n from '@/settings/i18n';
import { translateBackendError } from '@/lib/formatStatusCodeError';

const t = i18n.init('auth');

const ForgotPasswordStep = ({ setStep, data, setData }: StepProps) => {
  const { cognitoForgotPassword, loading } = useCustomerContext();
  const [error, setError] = useState('');

  const isValidEmail = useMemo(() => _isValidEmail(data.email), [data.email]);

  const onContinueClick = async () => {
    try {
      const auth = await cognitoForgotPassword(data.email);

      if (!auth.error) {
        setStep(AUTH_STEPS.RESET_PASSWORD);
      } else {
        setError(
          translateBackendError(
            auth.message,
            t`Couldn't send password reset email. Try again`,
          ),
        );
      }
    } catch (e) {
      setError(t`Couldn't send password reset email. Try again`);
    }
  };

  return (
    <div className="mt-2.5">
      <input
        className="h-12 w-full rounded border border-gray-700/10 px-3 text-gray-700 outline-1 outline-gray-700 placeholder:text-gray-700/50"
        placeholder={t`Enter your email...`}
        type="email"
        value={data.email}
        onChange={(e) => {
          if (error) {
            setError('');
          }
          setData({ ...data, email: e.target.value });
        }}
      />

      <CtaButton
        type="submit"
        className="mt-2 !h-12 w-full !rounded !text-sm"
        onClick={onContinueClick}
        loading={loading}
        disabled={!isValidEmail}
      >
        {t`Get Verification Code`}
      </CtaButton>
      {error ? <div className="text-sm text-red">{error}</div> : null}
    </div>
  );
};

export default ForgotPasswordStep;
